// extracted by mini-css-extract-plugin
export default {"wrapper":"CourtSchema_wrapper__uDEMH","img":"CourtSchema_img__+W0+Y","subTitle":"CourtSchema_subTitle__eRBmG"};